import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { Container } from '../../../../components/NPS/components/RatingDefinition/Container.js';
import { LabelXSmall, LabelXSmallBold } from '../../../../primitives/index.js';
export const RatingDefinition = React.memo(({
  min,
  max,
  minLabel,
  maxLabel
}) => {
  return _jsxs(Container, {
    children: [_jsxs("div", {
      children: [_jsx(LabelXSmallBold, {
        color: "contentSecondary",
        children: min
      }), minLabel && _jsx(LabelXSmall, {
        color: "contentSecondary",
        children: minLabel
      })]
    }), _jsxs("div", {
      children: [_jsx(LabelXSmallBold, {
        color: "contentSecondary",
        children: max
      }), maxLabel && _jsx(LabelXSmall, {
        color: "contentSecondary",
        children: maxLabel
      })]
    })]
  });
});